import { useContext } from 'react';
import { DailySettlementContext, IDailySettlementContext } from './DailySettlementContext';

export const useDailySettlement = () => useContext<IDailySettlementContext>(DailySettlementContext);
